import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function getUserDetailsApi(accessJWT: string, userId: string) {
  const URL = `${ENDPOINT}/app/v1/users/userId`;
  const body = {
    id: userId,
  };
  let config = getHeaderConfig(null, accessJWT);
  if (!accessJWT || !isValidJWT(accessJWT)) return null;
  try {
    if (!accessJWT) return null;
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      const parseData = JSON.parse(decryptedData);
      if (parseData?.data) return parseData.data;
      return null;
    } else return null;
  } catch (error: any) {
    return null;
  }
}
